export enum PlacementType {
  APARTMENT = 'APARTMENT',
  HOUSE = 'HOUSE',
  COMMERCIAL = 'COMMERCIAL',
  OTHER = 'OTHER',
}

export const placementTypeGermanStrings: { [k in keyof typeof PlacementType]: string } = {
  APARTMENT: 'Ein-/Zweifamilienhaus',
  HOUSE: 'Mehrfamilienhaus',
  COMMERCIAL: 'Gewerbeobjekt',
  OTHER: 'Sonstiges',
}
